export default __webpack_public_path__ + "static/logo-385bf93f58f5c928aadcdbb586a1c857.png";